import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return <header className="w-full bg-[#E55A88] text-white py-3" data-id="element-96">
      <div className="max-w-5xl mx-auto px-5 sm:px-6 md:px-8 flex items-center justify-between" data-id="element-97">
        <div className="text-xl font-bold" data-id="element-98">
          <span className="text-white" data-id="element-99">•MENOBLOOM•</span>
        </div>
        {/* Mobile menu button */}
        <div className="md:hidden" data-id="element-100">
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-white p-2" aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-101">
            {mobileMenuOpen ? <XIcon size={24} data-id="element-102" /> : <MenuIcon size={24} data-id="element-103" />}
          </button>
        </div>
        {/* Desktop navigation */}
        <nav className="hidden md:flex space-x-6" data-id="element-104">
          <a href="https://trymenobloom.com/products/meno-bloom" className="hover:text-pink-100 text-sm" data-id="element-105">
            Home
          </a>
          <a href="https://trymenobloom.com/products/meno-bloom" className="hover:text-pink-100 text-sm" data-id="element-106">
            About
          </a>
          <a href="https://trymenobloom.com/products/meno-bloom" className="hover:text-pink-100 text-sm" data-id="element-107">
            Science
          </a>
          <a href="https://trymenobloom.com/products/meno-bloom" className="hover:text-pink-100 text-sm" data-id="element-108">
            Reviews
          </a>
          <a href="https://trymenobloom.com/products/meno-bloom" className="hover:text-pink-100 text-sm" data-id="element-109">
            FAQ
          </a>
        </nav>
      </div>
      {/* Mobile navigation */}
      {mobileMenuOpen && <div className="md:hidden bg-pink-600 px-5 py-3" data-id="element-110">
          <nav className="flex flex-col space-y-4" data-id="element-111">
            <a href="https://trymenobloom.com/products/meno-bloom" className="hover:text-pink-100 text-sm py-2" data-id="element-112">
              Home
            </a>
            <a href="https://trymenobloom.com/products/meno-bloom" className="hover:text-pink-100 text-sm py-2" data-id="element-113">
              About
            </a>
            <a href="https://trymenobloom.com/products/meno-bloom" className="hover:text-pink-100 text-sm py-2" data-id="element-114">
              Science
            </a>
            <a href="https://trymenobloom.com/products/meno-bloom" className="hover:text-pink-100 text-sm py-2" data-id="element-115">
              Reviews
            </a>
            <a href="https://trymenobloom.com/products/meno-bloom" className="hover:text-pink-100 text-sm py-2" data-id="element-116">
              FAQ
            </a>
          </nav>
        </div>}
    </header>;
};